var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreensIcon3B(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "m450,100c0,-27.16895 22.83105,-50 50,-50l200,0c27.16895,0 50,22.83105 50,50l0,400c0,27.16895 -22.83105,50 -50,50l-200,0c-27.16895,0 -50,-22.83105 -50,-50l0,-400z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    d: "m51,400c0,-27.16895 22.83105,-50 50,-50l200,0c27.16895,0 50,22.83105 50,50l0,100c0,27.16895 -22.83105,50 -50,50l-200,0c-27.16895,0 -50,-22.83105 -50,-50l0,-100z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m50,100.00001c0,-27.16895 22.83105,-50 50,-50l200,0c27.16895,0 50,22.83105 50,50l0,100.00001c0,27.16895 -22.83105,50 -50,50l-200,0c-27.16895,0 -50,-22.83105 -50,-50l0,-100.00001z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreensIcon3B);
export default __webpack_public_path__ + "static/media/screens-icon_3b.82ce538877a4bb484589b51a9b936a92.svg";
export { ForwardRef as ReactComponent };